export default "__VITE_ASSET__8d721086__"